export default __webpack_public_path__ + "static/210602_夏日活動強更預告_jp-75633659d35b31dc9bc2c7f7bd447b7e.webp";